const USAGE_COLORS = {
    "null": {
        "background-color": "#f5aa00",
        "color": "#000000"
    },
    "B0100": {
        "background-color": "#f56100",
        "color": "#000000"
    },
    "B2000": {
        "background-color": "#c8d861",
        "color": "#000000"
    },
    "B2001": {
        "background-color": "#aed88c",
        "color": "#000000"
    },
    "B2002": {
        "background-color": "#bca2d8",
        "color": "#000000"
    },
    "B2003": {
        "background-color": "#9eb5d8",
        "color": "#000000"
    },
    "B2004": {
        "background-color": "#94c7d8",
        "color": "#000000"
    },
    "BA": {
        "background-color": "#D8D0BA",
        "color": "#000000"
    },
    "B1700": {
        "background-color": "#DF7B9F",
        "color": "#FFFFFF"
    },
    "B9F": {
        "background-color": "#DF7B9F",
        "color": "#FFFFFF"
    },
    "B1711": {
        "background-color": "#DDEBDB",
        "color": "#000000"
    },
    "B1712": {
        "background-color": "#DDEBDB",
        "color": "#000000"
    },
    "BDB": {
        "background-color": "#DDEBDB",
        "color": "#000000"
    },
    "B2501": {
        "background-color": "#C7A864",
        "color": "#000000"
    },
    "B2502": {
        "background-color": "#C7A864",
        "color": "#000000"
    },
    "B1100": {
        "background-color": "#E51D1F",
        "color": "#FFFFFF"
    },
    "B1101": {
        "background-color": "#E51D1F",
        "color": "#FFFFFF"
    },
    "B0800": {
        "background-color": "#CEC2D7",
        "color": "#000000"
    },
    "B2600": {
        "background-color": "#D3855E",
        "color": "#FFFFFF"
    },
    "B2601": {
        "background-color": "#D3855E",
        "color": "#FFFFFF"
    },
    "B2602": {
        "background-color": "#D3855E",
        "color": "#FFFFFF"
    },
    "B2604": {
        "background-color": "#D3855E",
        "color": "#FFFFFF"
    },
    "B9999": {
        "background-color": "#FFFFFF",
        "color": "#000000"
    },
    "B0200": {
        "background-color": "#AFCB07",
        "color": "#000000"
    },
    "B07": {
        "background-color": "#AFCB07",
        "color": "#000000"
    },
    "B0221": {
        "background-color": "#CDE5EA",
        "color": "#000000"
    },
    "B1600": {
        "background-color": "#0D9D79",
        "color": "#FFFFFF"
    },
    "B1610": {
        "background-color": "#12A883",
        "color": "#FFFFFF"
    },
    "B1611": {
        "background-color": "#12A883",
        "color": "#FFFFFF"
    },
    "B1510": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1511": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1512": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1513": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1514": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1515": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1516": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1517": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1518": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1519": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1520": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "BF6CD": {
        "background-color": "#FBF6CD",
        "color": "#000000"
    },
    "B1531": {
        "background-color": "#508B37",
        "color": "#FFFFFF"
    },
    "B1533": {
        "background-color": "#508B37",
        "color": "#FFFFFF"
    },
    "B1534": {
        "background-color": "#508B37",
        "color": "#FFFFFF"
    },
    "B1535": {
        "background-color": "#508B37",
        "color": "#FFFFFF"
    },
    "B1536": {
        "background-color": "#508B37",
        "color": "#FFFFFF"
    },
    "B37": {
        "background-color": "#508B37",
        "color": "#FFFFFF"
    },
    "B1540": {
        "background-color": "#FFED00",
        "color": "#000000"
    },
    "B1541": {
        "background-color": "#FFED00",
        "color": "#000000"
    },
    "B0600": {
        "background-color": "#EC6706",
        "color": "#000000"
    },
    "B0300": {
        "background-color": "#FECC00",
        "color": "#000000"
    },
    "B0311": {
        "background-color": "#FECC00",
        "color": "#000000"
    },
    "B0312": {
        "background-color": "#9B578F",
        "color": "#FFFFFF"
    },
    "B0313": {
        "background-color": "#9B578F",
        "color": "#FFFFFF"
    },
    "B578F": {
        "background-color": "#9B578F",
        "color": "#FFFFFF"
    },
    "B2100": {
        "background-color": "#98CCC5",
        "color": "#FFFFFF"
    },
    "B2101": {
        "background-color": "#98CCC5",
        "color": "#FFFFFF"
    },
    "B2102": {
        "background-color": "#98CCC5",
        "color": "#FFFFFF"
    },
    "B2103": {
        "background-color": "#98CCC5",
        "color": "#FFFFFF"
    },
    "B2105": {
        "background-color": "#98CCC5",
        "color": "#FFFFFF"
    },
    "B3000": {
        "background-color": "#BCDCF5",
        "color": "#000000"
    },
    "BCDCF5": {
        "background-color": "#BCDCF5",
        "color": "#000000"
    },
    "B1550": {
        "background-color": "#FCEBF2",
        "color": "#000000"
    },
    "B1551": {
        "background-color": "#FCEBF2",
        "color": "#000000"
    },
    "B1552": {
        "background-color": "#FCEBF2",
        "color": "#000000"
    },
    "B1553": {
        "background-color": "#FCEBF2",
        "color": "#000000"
    },
    "B1554": {
        "background-color": "#FCEBF2",
        "color": "#000000"
    },
    "B1555": {
        "background-color": "#FCEBF2",
        "color": "#000000"
    },
    "B1556": {
        "background-color": "#FCEBF2",
        "color": "#000000"
    },
    "BF2": {
        "background-color": "#FCEBF2",
        "color": "#000000"
    },
    "B1810": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B1811": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B1812": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B1813": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B1814": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B1815": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B1816": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B1817": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B2900": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B2901": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B2902": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B2903": {
        "background-color": "#E1E4E1",
        "color": "#000000"
    },
    "B1000": {
        "background-color": "#9E89C2",
        "color": "#FFFFFF"
    },
    "B0500": {
        "background-color": "#21B9EB",
        "color": "#FFFFFF"
    },
    "B0501": {
        "background-color": "#21B9EB",
        "color": "#FFFFFF"
    },
    "B0502": {
        "background-color": "#21B9EB",
        "color": "#FFFFFF"
    },
    "B9EB": {
        "background-color": "#21B9EB",
        "color": "#FFFFFF"
    },
    "B2400": {
        "background-color": "#6FF",
        "color": "#000000"
    },
    "B0900": {
        "background-color": "#5F8DA8",
        "color": "#FFFFFF"
    },
    "B0901": {
        "background-color": "#5F8DA8",
        "color": "#FFFFFF"
    },
    "B0400": {
        "background-color": "#008BD2",
        "color": "#FFFFFF"
    },
    "B0401": {
        "background-color": "#008BD2",
        "color": "#FFFFFF"
    },
    "B0421": {
        "background-color": "#008BD2",
        "color": "#FFFFFF"
    },
    "BD2": {
        "background-color": "#008BD2",
        "color": "#FFFFFF"
    },
    "B2200": {
        "background-color": "#FFC",
        "color": "#000000"
    },
    "B2300": {
        "background-color": "#6CF",
        "color": "#FFFFFF"
    }
};

export default USAGE_COLORS;
